import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

function setIframeTitles(root: HTMLElement = document.body) {
    const iframes = root.querySelectorAll("iframe");

    iframes.forEach((iframe) => {
        const src = iframe.getAttribute("src");
        const dataSrc = iframe.getAttribute("data-src");
        let title = "Eingebetteter Inhalt";

        try {
            const srcToUse = src;

            if (srcToUse) {
                // Stelle sicher, dass der `src` korrekt als absolute URL geparst wird
                const url = new URL(srcToUse, window.location.href);
                const hostname = url.hostname.replace("www.", "");
                const domainName = hostname.split(".")[0];
                const prettyDomain = domainName.charAt(0).toUpperCase() + domainName.slice(1);

                title = `Inhalt von ${prettyDomain}`;
            }
        } catch (e) {
            console.warn("Ungültige URL im iframe:", src);
        }

        // Nur den title setzen, wenn er entweder nicht gesetzt oder der Standardwert ist
        if (!iframe.hasAttribute("title") || iframe.getAttribute("title") === "Eingebetteter Inhalt") {
            iframe.setAttribute("title", title);
        }
    });
}

// Debounced Version der Funktion (mit RxJS debounceTime)
function createDebouncedIframeTitleSetter() {
    return fromEvent(document.body, 'DOMSubtreeModified')
        .pipe(
            debounceTime(150) // Verzögert die Ausführung auf 150ms nach der letzten DOM-Änderung
        );
}

// Initialisierung nach DOM-Load
document.addEventListener("DOMContentLoaded", function () {
    // Initiales Setzen der Titel
    setIframeTitles();

    // RxJS Observable für DOM-Änderungen und Debouncing
    const debouncedSetIframeTitles$ = createDebouncedIframeTitleSetter();

    // MutationObserver konfigurieren
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            // Überprüfen, ob ein Knoten hinzugefügt wurde
            for (const node of mutation.addedNodes) {
                if (node instanceof HTMLElement) {
                    // Wenn es sich um ein 'iframe' handelt oder ein 'iframe' in einem Knoten ist
                    if (node.tagName === "IFRAME" || node.querySelector("iframe")) {
                        // Hier könnte der Code zum Setzen der 'title'-Attribute für Iframes eingefügt werden
                        setIframeTitles();  // Beispiel für eine Funktion zum Setzen der Titel
                    }
                }
            }
        }
    });

// Beobachtung starten
    observer.observe(document.body, {
        childList: true,  // Beobachten von Hinzufügungen und Entfernen von Kindknoten
        subtree: true,    // Beobachten des gesamten Subtrees, nicht nur des unmittelbaren Kindes
    });
});
